interface CloudflareStreamVideoProps {
	uid: string;
	poster?: string;
	caption?: string;
}

const CLOUDFLARE_STREAM_CUSTOMER_CODE = "customer-fgt8ltjzuiqghj0f";

export function CloudflareStreamVideo({ uid, poster, caption }: CloudflareStreamVideoProps) {
	const params = new URLSearchParams();
	if (poster) params.set("poster", poster);

	const iframe_src = `https://${CLOUDFLARE_STREAM_CUSTOMER_CODE}.cloudflarestream.com/${uid}/iframe${params.toString() ? `?${params.toString()}` : ""}`;

	return (
		<div>
			<div style={{ position: "relative", paddingTop: "56.25%" }}>
				<iframe
					src={iframe_src}
					style={{ border: "none", position: "absolute", top: 0, height: "100%", width: "100%" }}
					allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
					allowFullScreen
					title={`Cloudflare Stream video ${uid}`}
				/>
			</div>

			{caption && (
				<div style={{ marginTop: "0.5rem", fontStyle: "italic", textAlign: "center", color: "#666" }}>
					{caption}
				</div>
			)}
		</div>
	);
}

export default CloudflareStreamVideo;
